export default function Boardt() {
    return (
        <div className="divboard2">
            <div className="boards">
                <h2 className="titleboard">Inovação </h2>




                <h2 className="subboards">Investimos em <strong className="s">tecnologia de ponta,</strong> para oferecer <strong className="s">soluções eficientes</strong> diante dos desafios de cada empreendimento.</h2>
            </div>
            <div className="boards">
                <h2 className="titleboard">Sustentabilidade </h2>

                <h2 className="subboards">Integramos <strong className="s">práticas sustentáveis</strong>, reduzindo impactos ambientais e promovendo o <strong className="s">uso eficiente</strong> de recursos.</h2>
            </div>


        </div>)
}